import Page404 from "./Error404";

export default Page404